import React, { useState } from "react";
import "../../style/components.css";

const Header = ({ stats }) => {
  const [activeTab, setActiveTab] = useState("Day");

  // Default Titles
  const baseTitles = [
    "Total customers",
    "Total sales",
    "Completed orders",

  ];

  const values = {
    Day: stats
      ? [
          stats.totalCustomers.daily,
          stats.totalSales?.daily,
          stats.totalCompletedOrders?.daily,

        ]
      : ["0", "€ 0", "0"],
    Week: stats
      ? [
          stats.totalCustomers.weekly,
          stats.totalSales.weekly,
          stats.totalCompletedOrders.weekly,

        ]
      : ["0", "€ 0", "0"],
    Month: stats
      ? [
          stats.totalCustomers.monthly,
          stats.totalSales.monthly,
          stats.totalCompletedOrders.monthly,

        ]
      : ["0", "€ 0", "0"],
    Year: stats
      ? [
          stats.totalCustomers.yearly,
          stats.totalSales.yearly,
          stats.totalCompletedOrders.yearly,

        ]
      : ["0", "€ 0", "0"]
  };

  return (
    <div className="px-4 sm:px-10 py-0.5 overflow-x-hidden">
      <div className="flex flex-col items-start gap-4 w-full md:flex-row md:items-center md:justify-between md:gap-6 pt-4 pb-6">
        <h1 className="font-bold text-text1 whitespace-nowrap text-[24px] sm:text-[26px] md:text-[30px] md:leading-[36px]">
          Dashboard
        </h1>
        <div className="flex gap-2.5">
          {["Day", "Week", "Month", "Year"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`button ${activeTab === tab ? "active" : "inactive"}`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
      </div>
      <hr className=" mb-8 border-gray-300" />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 w-full">
        {baseTitles.map((title, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg p-3 sm:p-6 flex flex-col justify-center"
          >
            <h2 className="text-base font-normal text-text1 text-left">
              {title}
            </h2>
            <p className="text-3xl font-bold text-text1 text-right">
              {title === "Total sales" && "€ "}
              {values[activeTab][index]}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Header;
